let target = $(".gallery-tab__label");

$(".js-tab").each(function () {
  $(this).find(".gallery-tab__item").eq(0).show();
});

$(target).click(function () {
  if (!$(this).hasClass("disable")) {
    var thatIndex = $(this).index();
    $(".js-tab").each(function () {
      $(this).find(".gallery-tab__item").fadeOut("fast");
      $(this).find(".gallery-tab__item").eq(thatIndex).fadeIn("fast");
    });
  }
});
